import React, { useState } from 'react';

import { translations } from '@/locale';
import { getMeals } from '@/services/api/meals';

import PaginatedTable from '@/components/ui/paginated';
import { TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

import { urls } from '@/constants';
import Refresh from '@/components/Refresh';
import { Input } from '@/components/ui/input';

export interface Props {
  vendorId: string;
}

const MealsListPage: React.FC<Props> = ({ vendorId }) => {
  const [term, setTerm] = useState('');

  return (
    <Refresh>
      {({ refresh, key }) => (
        <div className="space-y-4">
          <span>The products you&apos;re selling are automatically synced with Ebriza.</span>

          <Input placeholder="Filter by name or description" onChange={(e) => setTerm(e.target.value)} />

          <PaginatedTable
            key={JSON.stringify({ term, key })}
            source={(page, size) => getMeals(vendorId, { page, size, term: term })}
            renderHeader={() => (
              <TableHeader>
                <TableRow>
                  <TableHead key="name">Name</TableHead>
                  <TableHead key="price">Price</TableHead>
                </TableRow>
              </TableHeader>
            )}
          >
            {(meals) => (
              <TableBody>
                {meals.map((meal) => (
                  <TableRow key={meal.id} url={urls.menu.detail.get(meal.id)}>
                    <TableCell>
                      <div className="flex space-x-2">
                        <img
                          src={meal.thumbnailUrl}
                          className="object-cover w-10 h-10 bg-gray-200 rounded-lg"
                          loading="lazy"
                        />
                        <div className="flex flex-col">
                          <div className="text-sm font-medium text-gray-900">{meal.title}</div>
                          <div className="text-sm font-medium text-gray-900">{meal.description}</div>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      {meal.price}
                      <span> RON</span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </PaginatedTable>
        </div>
      )}
    </Refresh>
  );
};

export default MealsListPage;
